import React from 'react';
import { Typography, useMediaQuery } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { useTranslation } from 'services/localization/useTranslation';
import classNames from 'classnames';
import { OrderInfoDelivery } from 'common/types';
import { RentalsTabValues } from 'services/types';
import { RiTruckLine, RiArrowLeftLine } from 'react-icons/ri';
import { SELF_RETURN_CARRIER } from 'common/modules/delivery/constants';

interface Props {
	delivery: OrderInfoDelivery;
	rentalTab: RentalsTabValues;
}

const RentalCardDeliveryStatus = (props: Props) => {
	const classes = useStyles();
	const { delivery, rentalTab } = props;
	const { t } = useTranslation();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	const renderPickupLabel = () => (
		<>
			<RiTruckLine className={classNames(classes.deliveryIcon, classes.verticalFilp)} />
			{!isMobile && (
				<Typography className={classes.deliveryLabel} variant="body2">
					{t('delivery.pickup')}
				</Typography>
			)}
		</>
	);

	const renderSelfReturn = () => (
		<>
			<RiArrowLeftLine className={classNames(classes.deliveryIcon)} />
			{!isMobile && (
				<Typography className={classes.deliveryLabel} variant="body2">
					{t('delivery.selfReturn', 'Self-return')}
				</Typography>
			)}
		</>
	);

	switch (rentalTab) {
		case 'BOOKED':
			return !!delivery.to ? (
				<div className={classNames(classes.statusDiv, classes.deliveryStatus)}>
					<RiTruckLine className={classes.deliveryIcon} />
					{!isMobile && (
						<Typography className={classes.deliveryLabel} variant="body2">
							{t('delivery.delivery')}
						</Typography>
					)}
				</div>
			) : null;
		case 'ACTIVE':
			return !!delivery.from ? (
				<div className={classNames(classes.statusDiv, classes.deliveryStatus)}>
					{delivery.from.carrierId === SELF_RETURN_CARRIER.id
						? renderSelfReturn()
						: renderPickupLabel()}
				</div>
			) : null;
		default:
			return null;
	}
};
const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		statusDiv: {
			padding: theme.spacing(1),
			alignItems: 'center',
			display: 'flex',
		},
		deliveryStatus: {
			backgroundColor: theme.palette.background.secondary,
			marginLeft: theme.spacing(1),
		},
		deliveryLabel: {
			fontWeight: 500,
		},
		deliveryIcon: {
			height: '18px',
			marginRight: theme.spacing(0.5),
			[theme.breakpoints.down('md')]: {
				marginRight: 0,
			},
		},
		verticalFilp: {
			transform: 'scale(-1, 1)',
		},
	}),
);
export default RentalCardDeliveryStatus;
